'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function toPathComponents(path = '') {
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
}

exports.toPathComponents = toPathComponents;
